import httpManager from "@/app/shared/utils/httpManager";

export async function fetchAllCards() {
  const url = `/billing/cards/`;
  const resonse = await httpManager.get(url);
  return resonse.data?.results;
}
